







/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';
import StoreDispatcher from '@service/StoreDispatcher';
import ApplyMixin from '@mixin/apply';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    data() {
        return {
            projectFetched: false,
        }
    },

    mixins: [
        ApplyMixin,
    ],

    created() {
        if (this.projectId && this.isProject) {
            StoreDispatcher.fetchCurrentProject(this.projectId).then(project => {
                this.projectFetched = true;
            });
        } else {
            this.projectFetched = true;
        }
    },

    destroyed() {

    },
})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class ApplyProject extends Vue {}

